var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"indicator",class:{ 'indicator_available': _vm.isAvailable }}),_vm._v(" "+_vm._s(_vm.isAvailable ? 'В наличии' : 'Отсутствует')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }